// Section 8: Woodcutter. 3.0 wood. Axe 1.8x; 5% injury. Heavy job (+0.2 food demand).
// Constants: config.jobs.woodcutter, config.needs.heavyJobFoodSurcharge.
import type { Config } from '../../config';
import { alwaysEligible, heavyJobDemand, produced } from '../../core/content-helpers';
import { defineJob } from '../../core/registry';

export function woodcutter(config: Config) {
  const c = config.jobs.woodcutter;

  return defineJob({
    id: 'woodcutter',
    label: 'Woodcutter',
    section: 'S8',
    heavy: true,
    output: { kind: 'stock', resource: 'wood' },
    baseYield: c.yield,
    toolFactor: c.toolFactor,
    toolWear: 0,
    risks: { injury: c.injury },
    riskIllness: null,
    requiresBuilding: null,
    minStrength: 0,
    modifierTargets: ['demand'],
    modifierKeys: { demand: ['food'] },
    modifiers: heavyJobDemand('woodcutter', config.needs.heavyJobFoodSurcharge),
    produce: (_ctx, _worker, output) => (output > 0 ? [produced('wood', output)] : []),
    eligible: alwaysEligible,
  });
}
